import LoginTemplate from 'components/login/LoginTemplate';

const LoginPage = () => {
  return <LoginTemplate />;
};

export default LoginPage;
